module.exports = __webpack_public_path__ + "static/media/Roboto-Medium22.7ed83e14.ttf";